import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import _ from 'lodash'

import {
  UPDATE_SPECIFICATIONS,
  UPDATE_SPEC_SOURCES,
  UPDATE_EDIT_VALUE,
  UPDATE_SELECTED_REVISION,
  CLEAR_EDIT_VALUE,
  TOGGLE_REVISION_DIALOG,
  TOGGLE_HIDE_SPECIFICATIONS_TABLE,
  TOGGLE_IMPORT_DIALOG,
  UPDATE_IMPORT_SKUS_LIST,
  FETCH_SPECIFICATIONS_START,
  FETCH_SPECIFICATIONS_SUCCESS,
  FETCH_SPECIFICATIONS_ERROR,
  POST_SPECIFICATIONS_START,
  POST_SPECIFICATIONS_SUCCESS,
  POST_SPECIFICATIONS_ERROR,
  IMPORT_SPECIFICATION_START,
  IMPORT_SPECIFICATION_SUCCESS,
  IMPORT_SPECIFICATION_ERROR
} from './constants'


const updateEditValue = (prev, { value }) => value
const updateProductSpecs = (prev, { array }) => _.merge(_.cloneDeep(prev), array)
const updateImportSkusList = (prev, { array }) => array
const updateSpecSources = (prev, { value }) => value
const updateSelectedRevision = (prev, { value }) => value
const updateHideSpecsTable = (prev, { value }) => value
const toggleFlag = (value) => !value

const editSliceReducer = createReducer(false, {
  [CLEAR_EDIT_VALUE]: () => false,
  [UPDATE_EDIT_VALUE]: updateEditValue
})

const productSpecsReducer = createReducer([], {
  [UPDATE_SPECIFICATIONS]: updateProductSpecs,
  [UPDATE_SPEC_SOURCES]: updateSpecSources
})

const loadingStart = [[FETCH_SPECIFICATIONS_START],[POST_SPECIFICATIONS_START],[IMPORT_SPECIFICATION_START]]
const loadingSuccess = [[FETCH_SPECIFICATIONS_SUCCESS],[POST_SPECIFICATIONS_SUCCESS],[IMPORT_SPECIFICATION_SUCCESS]]
const loadingError = [[FETCH_SPECIFICATIONS_ERROR],[POST_SPECIFICATIONS_ERROR],[IMPORT_SPECIFICATION_ERROR]]
let loadingStates = loadingStart.concat(loadingSuccess, loadingError)
let reducerObj = {}
loadingStates.forEach(s => reducerObj[s] = toggleFlag)
const isLoadingReducer = createReducer(false, reducerObj)

const selectedRevisionReducer = createReducer('', {
  [UPDATE_SELECTED_REVISION]: updateSelectedRevision,
})

const importSkusListReducer = createReducer('', {
  [UPDATE_IMPORT_SKUS_LIST]: updateImportSkusList,
})

const toggleRevisionReducer = createReducer('', {
  [TOGGLE_REVISION_DIALOG]: toggleFlag,
})

const toggleImportReducer = createReducer('', {
  [TOGGLE_IMPORT_DIALOG]: toggleFlag,
})

const toggleHideSpecificationsTableReducer = createReducer('', {
  [TOGGLE_HIDE_SPECIFICATIONS_TABLE]: updateHideSpecsTable,
})

export default combineReducers({
  edit: editSliceReducer,
  productSpecs: productSpecsReducer,
  selectedRevision: selectedRevisionReducer,
  revisionDialogActive: toggleRevisionReducer,
  importDialogActive: toggleImportReducer,
  importSkusList: importSkusListReducer,
  isLoading: isLoadingReducer, 
  hideSpecificationsTable: toggleHideSpecificationsTableReducer, 
})
